import { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import axios from 'axios'
// import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { errorToast, successToast } from '../../../../../../../_metronic/helpers/components/Toaster'

type Props = {
    id: any
    data: any
    close: () => void
}

const IssueCouponModal: FC<Props> = ({ id, data, close }) => {

    console.log(" coupon user is ", id)

    const [coupons, setCoupons] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [selectedCouponId, setSelectedCouponId] = useState<string | null>(null)
    const [issuing, setIssuing] = useState(false)

    const getTokenFromStorage = () => {
        const authData = localStorage.getItem('kt-auth-react-v')
        if (authData) {
            try {
                const parsedData = JSON.parse(authData)
                return parsedData.data?.franchiseId
            } catch (e) {
                console.error('Error parsing auth data:', e)
            }
        }
        return null
    }

    useEffect(() => {
        const fetchCoupons = async () => {
            setLoading(true)
            try {
                const franchiseId = getTokenFromStorage()
                if (!franchiseId) {
                    errorToast('Franchise ID not found')
                    return
                }
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_API_URL}coupons/franchisee/${franchiseId}`
                )
                setCoupons(response.data)
            } catch (error) {
                console.error('Error fetching coupons:', error)
                errorToast('Failed to load coupons')
            } finally {
                setLoading(false)
            }
        }
        fetchCoupons()
    }, [])

    const handleIssueCoupon = async () => {
        if (!selectedCouponId) {
            errorToast('Please select a coupon')
            return
        }

        const selectedCoupon = coupons.find(c => c.id === selectedCouponId)
        const beneficiaryType = selectedCoupon?.beneficiaryUserType

        setIssuing(true)
        try {
            await axios.post(
                `${process.env.REACT_APP_BASE_API_URL}coupons/${selectedCouponId}/issue?issuedTo=${data.id}&beneficiaryType=${beneficiaryType}`
            )
            successToast('Coupon issued successfully')
            close()
        } catch (error) {
            console.error('Error issuing coupon:', error)
            errorToast('Failed to issue coupon')
        } finally {
            setIssuing(false)
        }
    }

    const handleRadioChange = (couponId: string) => {
        setSelectedCouponId(selectedCouponId === couponId ? null : couponId)
    }

    return createPortal(
        <div className="modal fade show d-block" style={{
            backgroundColor: 'rgba(0,0,0,0.5)',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 999999
        }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Issue coupon</h5>
                        <button type="button" className="btn-close" onClick={close}></button>
                    </div>
                    <div className="modal-body">
                        <table className='table table-striped' style={{ marginTop: '20px' }}>
                            <thead style={{ backgroundColor: '#f5f8fa' }}>
                                <tr>
                                    <th style={{ padding: '12px', fontSize: '12px', fontWeight: '600' }}>Icon</th>
                                    <th style={{ padding: '12px', fontSize: '12px', fontWeight: '600' }}>Name</th>
                                    <th style={{ padding: '12px', fontSize: '12px', fontWeight: '600' }}>Value</th>
                                    <th style={{ padding: '12px', fontSize: '12px', fontWeight: '600' }}>Type</th>
                                    <th style={{ padding: '12px', fontSize: '12px', fontWeight: '600' }}>Valid till</th>
                                    <th style={{ padding: '12px', fontSize: '12px', fontWeight: '600', textAlign: 'center' }}>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr><td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>Loading...</td></tr>
                                ) : coupons.length > 0 ? (
                                    coupons.map((coupon) => (
                                        <tr key={coupon.id}>
                                            <td style={{ padding: '12px' }}>
                                                <img
                                                    src={coupon.couponIcon || '/icons8-error-64.png'}
                                                    alt='icon'
                                                    onError={(e) => {
                                                        (e.target as HTMLImageElement).src = '/icons8-error-64.png'
                                                    }}
                                                    style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover' }}
                                                />
                                            </td>
                                            <td style={{ padding: '12px' }}>{coupon.couponName}</td>
                                            <td style={{ padding: '12px' }}>{coupon.couponValue}</td>
                                            <td style={{ padding: '12px' }}>{coupon.couponType}</td>
                                            <td style={{ padding: '12px' }}>{coupon.validityDate}</td>
                                            <td style={{ padding: '12px', textAlign: 'center' }}>
                                                {coupon.issuedTo?.includes(id.id) ? (
                                                    <span className="badge badge-light-success">Issued</span>
                                                ) : (
                                                    <input
                                                        type='radio'
                                                        name='coupon'
                                                        checked={selectedCouponId === coupon.id}
                                                        onChange={() => handleRadioChange(coupon.id)}
                                                    />
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>No coupons available</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={close}>Close</button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleIssueCoupon}
                            disabled={!selectedCouponId || issuing}
                        >
                            {issuing ? 'Issuing...' : 'Issue coupon'}
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    )
}

export { IssueCouponModal }